import { ContractPage } from "apps/oneOnboarding/contract/Page";
import { criticalMark } from "libs/analytics/criticalMark";

export default criticalMark(ContractPage, "ContractPage");
